// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3M46Z","label":"SetPasswdForm_label__7MgdS"};